<template>
    <span :class="[$style['mds-field-error'], classObject, sizeClass]" :data-mds-version="version">
        <slot>{{ text }}</slot>
    </span>
</template>

<script>
    // Import component's API
    import MdsFieldErrorProps from './field-error_props.js';

    export default {
        name: 'MdsFieldError',
        props: MdsFieldErrorProps,
        computed: {
            sizeClass() {
                return this.$style[`mds-field-error--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './field-error.scss';
</style>
